import React from 'react'
import { css } from '@emotion/css'
import { MenuOption } from '../../../legacy-design-system/popover'
import { FormattedMessage } from 'react-intl'
import { bodyCss } from '../../../legacy-design-system/text'

const menuOptionCss = css`
  padding: 6px 10px;
`
interface MenuActionBaseProps {
  testId?: string
  i18nTitleId: string
}

interface MenuActionProps extends MenuActionBaseProps {
  onClick: () => void
}

export const MenuAction: React.FC<MenuActionProps> = ({
  onClick,
  testId,
  i18nTitleId
}) => {
  return (
    <MenuOption className={menuOptionCss}>
      <span onClick={onClick} data-testid={testId}>
        <FormattedMessage id={i18nTitleId} />
      </span>
    </MenuOption>
  )
}

interface MenuLinkActionProps extends MenuActionBaseProps {
  href: string
}

export const MenuLinkAction: React.FC<MenuLinkActionProps> = ({
  href,
  testId,
  i18nTitleId
}) => {
  return (
    <MenuOption className={menuOptionCss}>
      <a
        data-testid={testId}
        href={href}
        target="_blank"
        className={css`
          ${bodyCss};
          &: hover {
            ${bodyCss};
            text-decoration: none;
          }
        `}
      >
        <FormattedMessage id={i18nTitleId} />
      </a>
    </MenuOption>
  )
}
